<template>
  <v-autocomplete
    v-model="collaborators"
    v-model:search="searchInput"
    :items="members"
    :loading="loading"
    label="Collaborators"
    item-title="full_name"
    item-value="id"
    autocomplete="off"
    multiple
    hide-details
    chips
    closable-chips
    class="app-select assign-to-member v-text-field--no-line"
    style="width: 100%"
    @update:model-value="searchInput = ''"
  >
    <!--    <template #chip="{ item }">-->
    <!--      <CommonChip closable @click:close="removeHandler(item.raw.id)">-->
    <!--        {{ item.raw.full_name }}-->
    <!--      </CommonChip>-->
    <!--    </template>-->
  </v-autocomplete>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

// import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default defineComponent({
  name: 'CollaboratorsSelect',

  // components: { CommonChip },

  props: {
    modelValue: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    members: {
      type: Array as PropType<{id: number; full_name: string}[]>,
      default: () => [],
    },
    loading: Boolean,
  },

  emits: ['update:modelValue'],

  data: (): { searchInput: string } => ({
    searchInput: '',
  }),

  computed: {
    collaborators: {
      get (): number[] {
        return this.modelValue;
      },
      set (value: number[]) {
        this.$emit('update:modelValue', value);
      },
    },
  },

  methods: {
    removeHandler (id: number) {
      const newValue = this.collaborators.filter((collaboratorId) => collaboratorId !== id);
      this.$emit('update:modelValue', newValue);
    },
  }
});
</script>
